export default __webpack_public_path__ + "static/logo-c17958387fe10ffb2530553a98d98b8e.svg";